import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { select } from 'satcheljs/lib/legacy';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export default select({
    optionState: function () { return store; },
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.SmartSuggestions);
    },
})(function isQuickSuggestionsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var smartSuggestionsEnabled = getFallbackValueIfNull(optionState.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
    var browserLocationEnabled = getFallbackValueIfNull(optionState.browserLocationEnabled, userOptions.browserLocationEnabled);
    return (smartSuggestionsEnabled !== userOptions.smartSuggestionsEnabled ||
        browserLocationEnabled !== userOptions.browserLocationEnabled);
});
//# sourceMappingURL=isQuickSuggestionsOptionDirty.js.map